// eslint-disable-next-line no-undef
module.exports = rem = (px) => `${Math.round((px / 16) * 1000) / 1000}rem`
